<template>
  <div class="form-group">
    <p>Búsqueda de Medicamentos
    <multiselect
      v-model="selectedMedicamento"
      :options="searchResults"
      label="nombre_busqueda"
      track-by="id"
      placeholder="Ingresa el nombre del medicamento"
      @search-change="searchMedicamentos"
      @select="selectMedicamento"
      :loading="isLoading"
      :clear-on-select="true"
      :close-on-select="true"
      :allow-empty="false"
    >
    </multiselect>
  </p>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
var config = require("@/config/api.json");
const API = config.api;

export default {
  name: "SearchMedicamentos",
  components: { Multiselect },
  data() {
    return {
      searchValue: '',
      searchResults: [],
      selectedMedicamento: null,
      isLoading: false
    };
  },
  props: {
    mainId: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    async searchMedicamentos(query) {
      console.log('Buscando medicamentos...', this.mainId, query);
      if (query.trim() === '') {
        this.searchResults = [];
        return;
      }
      this.isLoading = true;
      try {
        const response = await axios.post(`${API}/busqueda_medicamentos`, {
          params: {
            searchValue: query,
            personal_medico_id: this.mainId
          }
        });
        console.log(response.data);
        this.searchResults = response.data;
      } catch (error) {
        console.error(error);
        this.$emit('notify', 'error', `Error: ${error.message}`);
      } finally {
        this.isLoading = false;
      }
    },
    selectMedicamento(medicamento) {
      console.log(medicamento);
      this.searchResults = [];
      this.$emit('select', medicamento);
      setTimeout(() => {
        this.selectedMedicamento = null;
      }, 1000);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.autocomplete-results {
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.autocomplete-results li {
  padding: 8px;
  cursor: pointer;
}

.autocomplete-results li:hover {
  background-color: #f0f0f0;
}
</style>
